/** @module utils/flags */
/** Object containing flags. 
 * @type {Object} */
const flags = {
  ADD: 1,
  FULLTEXT_SEARCH: 2,
  CANCEL: 4,
  COPY: 8,
  SORT: 16,
  FILTER: 32,
  PAGING: 64,
  ONLY_SELECT: 128,
  // SELECT: 143, // ONLY_SELECT + COPY + CANCEL + ADD
  PRINT: 256,
  RESET: 512,
  GRID: 1024, //premenovanie z DEIT - 1. editovateľný; 2 - iba zobrazenie
  GRID_INLINE_EDIT: 2048, //premenovane z EDITALL
  DELETE: 4096, // DELETE
  GRID_CELL_EDIT: 8192,//premenovane z EDITCELL
  UPDATE: 16384, 
  TOOLBAR: 32768,
  COLUMN_MENU: 65536,
  COLUMN_SELECTED: 131072,
  USER_FILTER: 262144,
  SORT_DIALOG: 524288,
  DETAIL: 1048576,
  SAVE: 2097152,
  SAVE_NEW: 4194304,
  SAVE_BACK: 8388608,

  // NOTE: When adding a new flag, update ALL to include all previous values (next flag minus 1).
  ALL: 16_777_215,
}

export default flags;